import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL_BASE,  
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Oc-Merchant-Id': process.env.VUE_APP_MERCHANT_ID
  },
  timeout: 100000
})

function getFileExtension(filename) {
  return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
}

export default {

  async activate(iccid, subscriber, address, files, promo_code, employee_code = false, is_reseller = false) {    
    let formData = new FormData();
    for( var i = 0;(i < files.length && i <= 2); i++ ){
      let f = files[i];
      if(f.file) {
        var ext = getFileExtension(f.file.name)
        formData.append('files[' + i + ']', f.file, f.type + "." + ext);
      }      
    }
    formData.append("iccid", iccid);
    formData.append("subscriber", JSON.stringify(subscriber));
    formData.append("address", JSON.stringify(address));
    formData.append("promo_code", promo_code);
    formData.append("is_reseller", is_reseller);
    if(is_reseller) formData.append("employee_code", employee_code);
    
    return await apiClient.post('/subscriber/activate', 
      formData,
      {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      }
    );    
  },

  async partialActivate(iccid, subscriber, address, files, promo_code, employee_code = false, is_reseller = false) {    
    let formData = new FormData();
    for( var i = 0; (i < files.length && i <= 2); i++ ){
      let f = files[i];
      if(f.file) {
        var ext = getFileExtension(f.file.name)
        formData.append('files[' + i + ']', f.file, f.type + "." + ext);
      }     
    }
    formData.append("iccid", iccid);
    formData.append("subscriber", JSON.stringify(subscriber));
    formData.append("address", JSON.stringify(address));
    formData.append("promo_code", promo_code);
    formData.append("is_reseller", is_reseller);
    if(is_reseller) formData.append("employee_code", employee_code);

    return await apiClient.post('/subscriber/partialActivate', 
      formData,
      {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
      }
    );    
  },

  async getSubscriberByIccid(iccid, id_number) {    
    return await apiClient.post('/subscriber/getByIccid',{
      iccid: iccid,
      id_number: id_number
    }); 
  },

  async updateSubscriber(subscriber) {
    return await apiClient.post('/subscriber/update',{
      subscriber: subscriber
    }); 
  },

  async ricaSubscriber(subscriber, address, files) {
    return await apiClient.post('/subscriber/rica',{
      subscriber: subscriber,
      address: address,
      files: files
    }); 
  }

}

